module.exports = __webpack_public_path__ + "assets/img/邮箱.b30d955a.png";